<template>
  <div id="app">
    <navbar v-if="showNav && !appIsLoading"></navbar>
    <main class="container">
      <loading-spinner v-if="showNav && appIsLoading"></loading-spinner>
      <router-view v-else />
    </main>

    <modal-container />
  </div>
</template>

<script>
import Navbar from "./components/Navbar.vue";
import ModalContainer from "./components/modal-components/modal-container.vue";
import LoadingSpinner from "./components/LoaderSpinner.vue";
import firebase from "firebase";

export default {
  name: "App",
  components: {
    Navbar,
    ModalContainer,
    LoadingSpinner
  },
  computed: {
    showNav: function() {
      return this.$route.name != "Login";
    },
    appIsLoading: function() {
      return this.$store.getters.getLoadingStatus;
    }
  },
  created: function() {
    firebase.auth().onAuthStateChanged(user => {
      this.$store.dispatch("setUser");
      if (user) {
        this.$store.dispatch("fetchAllData").then(() => {
          const currentUserEmail = this.$store.getters.getUser.email;
          const currentUserInUsersList = this.$store.getters.getUsersList.find(
            user => {
              return user.data().email == currentUserEmail;
            }
          );
          if (currentUserInUsersList.data().admin == true) {
            this.$store.commit("setCurrentUserAdmin");
          }
        });
      }
    });
  }
};
</script>

<style lang="scss">
// Bulma/Buefy
@import "~bulma/sass/utilities/_all";

$primary: #009ad9;
$primary-invert: findColorInvert($primary);

$red: #e53935;
$red-invert: findColorInvert($red);
$yellow: #ffab00;
$yellow-invert: findColorInvert($yellow);
$green: #00c853;
$green-invert: findColorInvert($green);
$cyan: $primary;
$cyan-invert: findColorInvert($blue);
$info: $primary;
$info-invert: $primary-invert;
$blue: $primary;
$blue-invert: $primary-invert;
$link: $primary;
$link-invert: $primary-invert;

$colors: (
  "white": (
    $white,
    $black
  ),
  "black": (
    $black,
    $white
  ),
  "light": (
    $light,
    $light-invert
  ),
  "dark": (
    $dark,
    $dark-invert
  ),
  "primary": (
    $primary,
    $primary-invert
  ),
  "info": (
    $primary,
    $primary-invert
  ),
  "success": (
    $green,
    $green-invert
  ),
  "warning": (
    $yellow,
    $yellow-invert
  ),
  "danger": (
    $red,
    $red-invert
  )
);

$navbar-breakpoint: 801px;

@import "~bulma";
@import "~buefy/src/scss/buefy";

// Sonar
@import "./scss/main.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue